import React from 'react';

const Privacy: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    <section className="bg-blue-50 pt-16 pb-16 mt-16">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-8">
        <h1 className="text-3xl font-bold mb-6 text-blue-800">隐私政策</h1>
        <div className="prose prose-blue max-w-none">
          <p>更新日期：2025年10月13日</p>
          <p>黄山智衣信息科技有限公司作为服帮帮微信小程序、APP、微信公众号、官方网站等一系列产品的运营者，深刻认识到个人信息安全对于您（以下亦称为 “用户”）的至关重要性。我们始终秉持高度的勤勉与审慎态度，严格依照法律法规的要求，采取全面且有效的安全保护措施，致力于确保您的个人信息安全、可控，切实维护您的隐私权益。</p>
          <p>在您开始使用我们的产品或服务之前，请务必仔细阅读并充分理解本隐私政策的全部内容。只有在您完全理解并同意本政策的前提下，方可开始使用相关产品或服务。一旦您使用或继续使用我们的产品或服务，即表明您已认可并同意我们按照本隐私政策的规定处理您的相关信息。同时，服帮帮会依据相关政策法规的变化，适时对本隐私政策进行更新，以确保其始终符合最新的法律要求和用户需求。</p>
          <p>通过本《隐私政策》，您能够全面了解以下关键内容：</p>
          <ul>
            <li>信息收集</li>
            <li>信息披露</li>
            <li>信息存储与交换</li>
            <li>数据权属与使用</li>
            <li>信息安全</li>
            <li>信息注销</li>
          </ul>
          <h2>1. 信息收集与使用</h2>
          <p>在未获得您明确许可之前，服帮帮坚决不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息。当经您许可的第三方和服帮帮共建单位为您提供的服务结束后，我们将严格禁止该第三方继续访问您的资料，并要求其立即删除相关信息。同时，我们绝不允许任何第三方擅自收集、编辑、出售、传播您的个人信息。若发现服帮帮平台用户存在上述违规行为，我们有权立即终止与该用户的服务协议，以维护平台的安全与秩序。</p>
          <p>在您使用我们的产品或服务过程中，存在以下需要您选择是否授权我们收集和使用个人信息的具体场景：</p>
          <h3>1.1 注册账号及企业认证</h3>
          <p>当您注册服帮帮账号时，为确保注册流程的顺利完成，您需要提供手机号码及手机验证码。注册成功后，您可根据自身业务需求，自主选择是否进行企业认证操作。若进行企业认证，您需完善公司名称、营业执照编号及图片、公司电话、公司地址、业务负责人及联系电话等详细信息，以便后续业务的顺利开展。</p>
          <h3>1.2 图片获取、存储与上传</h3>
          <p>为实现上传图片、上传头像、上传视频的功能，我们需要获取您设备的“存储-读取外置存储器”权限与摄像头的使用权限；</p>
          <h3>1.3 设备信息、网络信息、应用已安装列表</h3>
          <p>在您使用服帮帮时，为了您能更好的体验产品功能，我们将获取设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI、地理位置数据、蓝牙信息等）、网络信息、应用已安装列表等权限。</p>
          <h3>1.4 与服帮帮服务商沟通</h3>
          <p>您接听或拨打服帮帮服务商电话可能会被录音，当服务商与客户出现服务纠纷时，经纠纷任意方授权，平台可调取并使用录音信息作为解决纠纷的参考依据。除法律要求保留的情形外，录音在被保留7天后会自动删除，如遇尚未处理完毕的纠纷，平台可能适当延长录音的保存期限。</p>
          <h3>1.5 服帮帮通过合法途径从商业伙伴处取得的用户个人数据</h3>
          <p>注：以下信息不适用本隐私政策：</p>
          <ol>
            <li>服帮帮收集到的您在服帮帮发布的有关信息数据，如参与活动、成交信息及评价详情、求职招聘信息等公开透明的信息。</li>
          </ol>
          <h3>1.6 违反法律规定或违反服帮帮规则行为及服帮帮已对您采取的措施。</h3>
          <h2>2. 信息披露</h2>
          <p>我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息。</p>
          <p>在如下情况下，服帮帮将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
          <h3>2.1 经您事先同意，向第三方披露</h3>
          <p>在获得您明确的书面或电子形式的同意后，我们将按照您同意的范围和方式向第三方披露您的个人信息。</p>
          <h3>2.2 因服务需要与授权合作伙伴共享</h3>
          <p>当您使用服帮帮时，为提供您所要求的部分产品和服务，可能需要借助授权合作伙伴提供的 SDK 来协助完成，或者由授权合作伙伴的 SDK 直接提供某些服务。在这种情况下，我们必须和第三方分享您的个人信息。我们会严格审查这些 SDK 提供商的业务准入资质，确保其具备合法合规性和安全性，并与其共同建立完善的机制来保护您的个人信息安全，防止您的信息遭受未经授权的访问、使用或披露。SDK 提供商收集和处理信息等行为遵守其自身的隐私权政策。服帮帮中集成了下述 SDK，当您使用这些特定产品时，SDK 的应用场景，使用的权限及适用的第三方隐私政策如下所列：</p>
          <ul>
            <li>uni-app：<br />代码包名：io.dcloud<br />应用场景：app基础模块功能的实现<br />使用的权限：存储的个人文件、设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI）、位置信息、网络信息<br />隐私政策链接/官网：https://uniapp.dcloud.net.cn/</li>
            <li>阿里weexSDK：<br />代码包名：com.taobao<br />应用场景：uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎<br />使用的权限：存储的个人文件<br />隐私政策链接/官网：http://doc.weex.io/zh</li>
            <li>fastjson：<br />代码包名：com.alibaba.fastjson<br />应用场景：JSON解析<br />使用的权限：无<br />隐私政策链接/官网：https://github.com/alibaba/fastjson</li>
            <li>移动安全联盟 OAID：<br />代码包名：com.bun.miitmdid、com.zui.opendeviceidlibrary<br />应用场景：获取oaid<br />使用的权限：设备信息<br />隐私政策链接/官网：http://www.msa-alliance.cn/col.jsp?id=105</li>
            <li>高德开放平台：<br />代码包名：com.amap.api、 com.loc、com.autonavi<br />应用场景：实现定位/展现地图<br />使用的权限：存储的个人文件、位置信息、读取手机状态和身份、网络信息<br />隐私政策链接/官网：https://lbs.amap.com/pages/privacy/</li>
            <li>支付宝开放平台：<br />代码包名：com.alipay<br />应用场景：用于唤起支付宝完成支付<br />使用的权限：网络信息<br />隐私政策链接/官网：https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132</li>
            <li>微信开放平台：<br />代码包名：com.tencent.mm<br />应用场景：登录、分享、支付<br />使用的权限：存储的个人文件、网络信息<br />隐私政策链接/官网：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</li>
            <li>友盟统计：<br />SDK名称：友盟统计分析SDK<br />使用目的：进行APP运营统计与分析<br />运营方：友盟同欣（北京）科技有限公司<br />收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息<br />隐私政策链接/官网：https://www.umeng.com/page/policy</li>
          </ul>
          <h3>2.3 根据法律规定或行政、司法机构要求披露</h3>
          <p>根据法律的有关规定，或者应行政或司法机构的合法要求，我们将向第三方或者行政、司法机构披露您的个人信息，以配合相关法律程序的进行。</p>
          <h3>2.4 因用户违规行为披露</h3>
          <p>如您出现违反中国有关法律、法规或者服帮帮服务协议或相关规则的情况，为维护平台秩序和其他用户的合法权益，我们需要向第三方披露相关信息。</p>
          <h3>2.5 知识产权投诉处理披露</h3>
          <p>如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，我们将向被投诉人披露必要的信息，以便双方妥善处理可能的权利纠纷，促进知识产权的保护和合法使用。</p>
          <h3>2.6 交易相关披露</h3>
          <p>在服帮帮平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，为促成交易的完成或纠纷的解决，服帮帮有权决定向该用户提供其交易对方的联络方式等必要信息。</p>
          <h3>2.7 其他合理披露情形</h3>
          <p>其它服帮帮根据法律、法规或者网站政策认为合适的披露情形，我们将在充分考虑您的权益和法律规定的前提下，谨慎作出披露决定。</p>
          <h2>3. 信息存储和交换</h2>
          <p>服帮帮收集的有关您的信息和资料将保存在服帮帮及（或）其关联公司的服务器上。为了实现平台的全球化运营和服务优化，这些信息和资料可能会传送至您所在国家、地区或服帮帮收集信息和资料所在地的境外，并在境外被访问、存储和展示。我们将严格遵守相关法律法规和国际数据传输标准，确保数据在跨境传输过程中的安全性和合规性。</p>
          <h2>4. 数据权属与使用</h2>
          <h3>4.1 数据范围界定</h3>
          <p>本协议所指"数据"包括但不限于：</p>
          <p>（a）用户提供数据：用户为使用服务而主动上传、提交或发布的数据，包括用户信息、发布的订单信息、产能数据等。</p>
          <p>（b）平台生成数据：通过本系统采集、加工、生成的全部数据，包括但不限于用户登录信息、订单交易数据、工业设备数据、运维日志、数据分析报告，以及由服帮帮指派人员现场录入的数据等。</p>
          <p>（c）衍生数据：基于前述数据进行去标识化、匿名化、筛选、分析、计算、整合等加工后形成的所有数据、信息及统计分析成果。</p>
          <h3>4.2 数据权利归属</h3>
          <p>（a）用户对其上传的"用户提供数据"保留所有权。用户在此授予服帮帮一项全球范围内、免许可费的，以便服帮帮为提供、优化本服务及履行本协议之目的，对用户提供数据进行使用、存储、备份、复制、修改及展示。用户知晓并授权服帮帮对相关数据使用及对外经营权利。上述行为无需另行取得用户同意，且不影响用户在本协议授权范围内的正常使用权。我们承诺相关商业化利用不涉及您的个人隐私，不损害您的相关权利。</p>
          <p>（b）服帮帮对"平台生成数据"及"衍生数据"依法独立享有全部知识产权及财产性权益，包括但不限于持有权、使用权和经营收益权。</p>
          <h3>4.3 用户数据权利</h3>
          <p>在遵守本协议及适用法律的前提下，用户有权于其账户授权范围内，查询、查看及下载与其直接相关的设备原始数据副本。</p>
          <h3>4.4 商业化与经营</h3>
          <p>（a）用户知晓并同意，服帮帮有权对"平台生成数据"及"衍生数据"进行任何形式的商业化利用，由此产生的全部商业价值与收益由服帮帮独立享有，用户无权主张任何形式的分成或利益。</p>
          <p>（b）服帮帮享有本系统的独家经营权与商业化运营权，包括但不限于运营、再授权、转让或以其他方式进行商业化处置。上述安排无需另行取得用户同意或通知，且不影响用户在本协议项下的既有服务使用权。服帮帮承诺，在进行前述商业化利用时，将严格遵守相关法律法规，不侵害您的个人隐私及其他合法权益。</p>
          <h2>5. 信息安全</h2>
          <h3>5.1 平台安全措施</h3>
          <p>服帮帮帐号均配备了完善的安全保护功能。我们会通过对用户密码进行加密等多种安全措施，全力确保您的信息不丢失、不被滥用和变造。然而，尽管我们采取了上述安全措施，但由于信息网络的复杂性和不确定性，您也需了解在信息网络上不存在绝对 “完善的安全措施”，我们将持续努力提升安全防护水平，降低安全风险。</p>
          <h3>5.2 用户自我保护提示</h3>
          <p>在使用服帮帮网络服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您务必妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是服帮帮用户名及密码发生泄露，请您立即联络服帮帮客服，以便我们及时采取相应措施，保障您的账号安全和个人信息权益。</p>
          <h2>6. 账号注销</h2>
          <p>您可以登录服帮帮，按照以下注销流程进行操作：我的/设置/隐私安全/账户注销。在进行注销操作时，系统将要求您进行二次确认，以确保注销行为是您的真实意愿。请您知悉，一旦您完成账号注销操作，平台将无法继续为您提供服务，您亦无法继续使用该账号。在您主动注销账号之后，我们将严格依照法律、法规的要求，立即停止为您提供服务，并删除您的个人信息，或对其进行匿名化处理，以最大程度保护您的隐私安全。</p>
          <p>请注意，当您为账号注销与我们联系时，为了保障账号安全和您的合法权益，我们可能需要您提供相应信息证明您的身份和请求的正当性。对于不合理的请求，我们有权依据相关规定予以拒绝。</p>
        </div>
      </div>
    </section>
  </div>
);

export default Privacy; 